var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_197_1774)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.375,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#058AE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.62 30.285H12.38C11.8932 30.285 11.5 30.6782 11.5 31.165V32.155C11.5 32.276 11.599 32.375 11.72 32.375H33.28C33.401 32.375 33.5 32.276 33.5 32.155V31.165C33.5 30.6782 33.1067 30.285 32.62 30.285ZM15.5068 27.975C15.5618 27.975 15.6168 27.9695 15.6718 27.9613L20.2972 27.15C20.3523 27.139 20.4045 27.1143 20.443 27.073L32.1003 15.4157C32.1257 15.3903 32.146 15.3601 32.1598 15.3268C32.1736 15.2936 32.1807 15.2579 32.1807 15.2219C32.1807 15.1859 32.1736 15.1502 32.1598 15.1169C32.146 15.0837 32.1257 15.0534 32.1003 15.028L27.5297 10.4548C27.4775 10.4025 27.4087 10.375 27.3345 10.375C27.2602 10.375 27.1915 10.4025 27.1392 10.4548L15.482 22.112C15.4407 22.1532 15.416 22.2027 15.405 22.2577L14.5938 26.8832C14.567 27.0306 14.5766 27.1822 14.6216 27.325C14.6666 27.4678 14.7458 27.5974 14.8522 27.7027C15.0337 27.8787 15.262 27.975 15.5068 27.975Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_197_1774",
    x: 0.5,
    y: 0.375,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_197_1774"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_197_1774",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.95588757.svg";
export { ForwardRef as ReactComponent };